module.exports = __webpack_public_path__ + "static/media/2.75daaf01.jpg";